import { ProductBrandDetailPage } from '@/features/product-brand/pages/ProductBrandDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-brand/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_brand.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductBrandDetailPage,
})
